/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import ImageIndicator from 'material/embeds/imageindicator/imageindicator';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/background/background_styles';



/* ========== ~~~~~~~~~~ EMBED : BACKGROUND ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
class Background extends Component {
	constructor(props) {
		super(props);
        this.handleSelect = this.handleSelect.bind(this);
    }
    handleSelect() {
        this.props.setActiveSelection(this.props.isSelected ? 'none' : 'background')
    }
	render() {
		const bgImgURL = `url(${this.props.backgroundImageURL})`;
		const bgImgSrc = this.props.previewBackgroundImageURL === null ? bgImgURL : `url(${this.props.previewBackgroundImageURL})`;
		const bgColor = this.props.backgroundColor === null || this.props.backgroundColor === undefined ? 'rgba(48,48,48,0.8)' : this.props.backgroundColor;
	    return(
	    	<div className={`${this.props.classes.background} selected-${this.props.isEditable && this.props.isSelected}`} onClick={this.handleSelect}>
	    		<div className={`overlay`} />
		    	<div className={`fade`} style={{ background: bgColor }} />
		    	<div className={`image`} style={{ backgroundImage: bgImgSrc }} />
		    	<ImageIndicator color={`white`} />
		    </div>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Background);